export const DASHBOARD_START_LOADING = "DASHBOARD_START_LOADING";
export const DASHBOARD_END_LOADING = "DASHBOARD_END_LOADING";
export const DASHBOARD_LOADED = "DASHBOARD_LOADED";